/* eslint-disable */
import {ModalDispatch} from "../context/ModalContext";
import React, {useContext} from "react";
import FontSelector from "./FontSelector";
import {TextSectionsDispatch, TextSectionsListContext} from "../context/TextSectionsListContext";
import {ConfigContext} from "../context/ConfigContext";
import defaultData from '../data/defaultData.json';
import ConfigurationsService from "../services/ConfigurationsService";
import {SavedConfigurationsContext, SavedConfigurationsDispatch} from "../context/SavedConfigurationsContext";
import uuid from "draft-js/lib/uuid";
import {EditTypeContext, EditTypeDispatch} from "../context/EditTypeContext";
import {LoaderDispatch} from "../context/LoaderContext";
import PdfRenderer from "./PdfDocument";
import Price from "./Price";
import {AuthContext} from "../context/LoginContext";
import {PriceContext} from "../context/PriceContext";
import {WorkingSizeContext} from "../context/WorkingSizeContext";

export const AppNavigation = () => {
    const priceContext = useContext(PriceContext);
    const loaderDispatch = useContext(LoaderDispatch);
    const editTypeContext = useContext(EditTypeContext);
    const editTypeDispatch = useContext(EditTypeDispatch);
    const modalDispatch = useContext(ModalDispatch);
    const textSectionsDispatch = useContext(TextSectionsDispatch);
    const textSections = useContext(TextSectionsListContext);
    const config = useContext(ConfigContext);
    const user = useContext(AuthContext);
    const savedConfigurationsContext = useContext(SavedConfigurationsContext);
    const savedConfigurationsDispatch = useContext(SavedConfigurationsDispatch);
    const workingSize = useContext(WorkingSizeContext)
    const [errorMsg, setErrorMsg] = React.useState('');
    const [successMsg, setSuccessMsg] = React.useState('');
    const [configurationName, setConfigurationName] = React.useState('');

    function clearMessages() {
        setErrorMsg('');
        setSuccessMsg('');
    }

    function deactivateAllTextSections() {
        return new Promise((resolve) => {
            textSectionsDispatch({
                type: 'deactivateAllTextSections'
            });
            textSectionsDispatch({
                type: "removeEmptyTextSections"
            });
            resolve();
        })
    }

    function exportData(fromCart = false) {
        let id = editTypeContext.id !== null ? editTypeContext.id : uuid();
        const data = {
            id: id,
            name: editTypeContext.name,
            fontConfig: config,
            textSections: textSections.map((section, index) => {
                return {
                    value: section.value,
                    position: section.position,
                    fontSize: section.fontSize,
                    letterSpacing: section.letterSpacing,
                    fontSizeValue: section.fontSizeValue,
                    index: index,
                    rawContent: section.rawContent,
                    textAlign: section.textAlign,
                    active: section.active,
                }
            }),
            erpData: getListDataForERP(),
            price: priceContext,
            woocommerceProductId: config.selectedFontObject.woocommerce_product_id,
            workingSize: workingSize,
            fromCart: fromCart
        }
        //console.log('exportData', data);
        return data;
    }

    function resetTextSections() {
        const userConfirmed = confirm(
            "Zmiana czcionki spowoduje zresetowanie konfiguratora. Czy jesteś pewien że chcesz to zrobić?"
        );

        if (!userConfirmed) {
            return;
        }

        return new Promise((resolve) => {
            textSectionsDispatch({
                type: 'resetTextSections'
            });
            editTypeDispatch({
                type: 'setType',
                payload: 'save'
            });
            editTypeDispatch({
                type: 'setName',
                payload: ''
            });
            resolve();
        });
    }

    function setAsEdit() {
        return new Promise((resolve) => {
            const id = uuid();
            editTypeDispatch({
                type: 'setId',
                payload: id
            });
            editTypeDispatch({
                type: 'setType',
                payload: 'edit'
            });
            editTypeDispatch({
                type: 'setName',
                payload: 'cart Item'
            });
            resolve();
        });
    }

    // Funkcja pomocnicza do wyszukiwania id_erp po name w fontsSizesList
    function getFontSizeErpIdByName(name) {
        const found = config.fontsSizesList.find(item => item.font_size.name === name);
        return found ? found.font_size.id_erp : null;
    }

    const getListDataForERP = () => {

        const result =
            {
                Tekst: textSections[0] ? textSections[0].rawContent : [],
                Czcionka: config.selectedFontObject.font[0].id_erp,
                Mocowanie: config.selectedMountingObject.id_erp,
                Material: config.selectedMaterialObject.id_erp,
                //wykończenie tylko dla koloru srebrnego (id 196)
                Wykonczenie: config.selectedColorObject.id == 196 ? config.selectedTypeObject.id_erp : 3,
                Kolor: config.selectedColorObject.id_erp,
                NapisyPozycje: textSections.map((section, index) => {
                    const name = section.fontSize;
                    // Szukamy id_erp na podstawie nazwy
                    const fontId = getFontSizeErpIdByName(name);
                    return {
                        Tekst: section.rawContent,
                        RozmiarLiter: fontId,
                        RozmiarInterpunkcji: 11,
                    };
                }),
            }

        return result;
    }

    async function saveNewConfiguration() {
        clearMessages();
        const service = new ConfigurationsService();
        const response = await service.createConfiguration(exportData());
        //console.log('saveNewConfiguration', response);

        if (response.status === 'success') {
            setSuccessMsg('Konfiguracja została zapisana');
        } else {
            setErrorMsg('Błąd podczas zapisywania konfiguracji');
        }
    }

    async function refreshConfigurationLists() {
        const service = new ConfigurationsService();
        const response = await service.getConfigurations();
        //console.log('updateConfigurationLists', response);
        savedConfigurationsDispatch({
            type: 'set',
            payload: response
        });
    }

    async function handleAddConfiguration() {
        loaderDispatch({type: 'activate'});
        await saveNewConfiguration();
        await refreshConfigurationLists();
        loaderDispatch({type: 'deactivate'});
    }

    async function handleChangeConfiguration() {
        loaderDispatch({type: 'activate'});
        clearMessages();
        const service = new ConfigurationsService();
        const response = await service.editConfiguration(editTypeContext.id, exportData());
        //console.log('edit configuration ', response);

        if (response.status === 'success') {
            setSuccessMsg('Konfiguracja została zapisana');
        } else {
            setErrorMsg('Błąd podczas zapisywania konfiguracji');
        }
        loaderDispatch({type: 'deactivate'});
    }

    async function addToCart() {
        clearMessages();
        const data = exportData(true);
        const service = new ConfigurationsService();
        //zapisujemy konfigurację do koszyka dla niezalogowanych użytkowników
        const response = await service.createConfigurationForNotLoggedInUsers(data);
        //zapisujemy konfiguracje dla zalogowanych użytkowników, później ten konfigurację będzie można wczytać z aplikacji
        if (user.isLoggedIn) {
            await service.createConfiguration(data);
        }

        //save data to cookies, up to 1 month, we need this in cease if user want to edit cart item
        sessionStorage.setItem(`configurationData_${data.id}`, JSON.stringify(data));
        //console.log('saveNewConfiguration For not looged in users', response);

        if (response.status === 'success') {
            window.open(process.env.REACT_APP_WC_SITE_URL + 'koszyk?uuid=' + data.id, '_blank');
        } else {
            setErrorMsg('Błąd');
        }
    }

    function handleConfigurationNameChange(e) {
        setConfigurationName(e.target.value);
        editTypeDispatch({
            type: 'setName',
            payload: e.target.value
        })
    }

    return (
        <div className="nav-actions">
            <button
                onClick={addToCart}
                className="mt-4 btn btn--secondary"
                aria-label="Dodaj do koszyka"
                disabled={!priceContext.allowAddToCart}
                aria-disabled={!priceContext.allowAddToCart}
            >
                Dodaj do koszyka
            </button>
            <button
                className="btn"
                onClick={resetTextSections}
                type="button"
            >
                Nowy szablon roboczy
            </button>
            {user.isLoggedIn ?
                editTypeContext.type === 'save' ? (
                    <div style={{display: 'flex', gap: '2rem',}}>
                        <button
                            className={`btn${configurationName.length === 0 ? ' disabled' : ''}`}
                            onClick={handleAddConfiguration}
                            aria-disabled={configurationName.length === 0}
                            disabled={configurationName.length === 0}
                            type="button"
                        >
                            Zapisz szablon roboczy
                        </button>
                        <label htmlFor="configurationName" className="visually-hidden">Nazwa</label>
                        <input
                            type="text"
                            id="configurationName"
                            value={configurationName}
                            onChange={handleConfigurationNameChange}
                            placeholder="Nazwa szablonu robczego"
                            aria-label="Nazwa szablonu robczego"
                        />
                    </div>
                ) : (
                    <div style={{display: 'flex', gap: '2rem',}}>
                        <button
                            className="btn"
                            onClick={handleChangeConfiguration}
                            type="button"
                        >
                            Zapisz zmiany
                        </button>
                        <label htmlFor="editConfigurationName" className="visually-hidden">Nazwa szablonu</label>
                        <input
                            type="text"
                            id="editConfigurationName"
                            disabled
                            value={editTypeContext.name}
                            aria-label="Nazwa"
                        />
                    </div>
                )
                : <div className="nav-actions__info"
                       style={{marginTop: 'auto', color: '#333', background: '#fff', padding: '0.5rem'}}
                       aria-live="polite">
                    * Możesz zapisywać swoje konfiguracje dopiero po zalogowaniu
                </div>
            }
        </div>
    )
}
